import { cva } from 'class-variance-authority';
import { cn } from '@bridebook/aura';

const simple = cva(
  'flex items-center justify-center rounded-full px-4 py-1 text-sm font-semibold text-white active:opacity-80',
  {
    variants: {
      color: {
        primary: 'hover:bg-blue-700 bg-blush-tangerine-120',
        secondary: 'bg-purple-500 hover:bg-purple-700',
      },
      size: {
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
        '2xl': 'text-2xl',
      },
    },
  },
);

export const SimpleComponent = () => (
  <div className={cn(simple({ color: 'primary', size: '2xl' }))}>SimpleComponent</div>
);
